import React, { FunctionComponent } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from '../../../hooks/useTranslation';
import EmailTextField from '../../email-text-field';
import PasswordTextField from '../../password-text-field';
import PinTextField from '../../pin-text-field';
import RegistrationFormProps from '../registration.types';
import PasswordHelper from './PasswordHelper';

const UserAccountSection: FunctionComponent<
  RegistrationFormProps | any
> = props => {
  const { t } = useTranslation();
  const { form, isStartServiceForm } = props;

  return (
    <Grid
      container
      spacing={1}
      style={{
        padding: 0,
        justifyContent: 'flex-start',
      }}
    >
      {!isStartServiceForm && (
        <Grid item xs={12}>
          <Typography variant={'h2'}>{t('CREATE_SIGN_IN')}</Typography>
        </Grid>
      )}

      <Typography>{t('CREATE_SIGN_IN_DESCRIPTION')}</Typography>

      <Grid item xs={12} md={12}>
        <Grid item>
          <EmailTextField
            label={t('EMAIL_ADDRESS')}
            style={{ width: '100%' }}
            {...form.props('email')}
          />
        </Grid>
        {isStartServiceForm && (
          <Grid item>
            <FormControlLabel
              style={{ height: 50, marginTop: 10 }}
              control={
                <Checkbox
                  name={'registerForOnline'}
                  color={'primary'}
                  {...form.checkProps('registerForOnline')}
                />
              }
              label={t('ONLINE_ACCESS')}
            />
            <Typography variant="body2">
              {t('ONLINE_ACCESS_DESCRIPTION')}
            </Typography>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          style={{
            marginTop: 16,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            marginBottom: '16px',
          }}
        >
          <Grid item xs={12}>
            <PasswordTextField
              style={{ width: '100%' }}
              defaultShow={props.isMobile}
              inputProps={{ minLength: 8, maxLength: 16 }}
              {...form.props('password')}
            />
          </Grid>
          <PasswordHelper password={form.values.password} />
        </Grid>

        {!isStartServiceForm && (
          <Grid item xs={12} style={{ display: 'flex', position: 'relative' }}>
            <Grid item xs={12}>
              <PinTextField
                label={t('FOUR_DIGIT_PIN_CODE')}
                placeholder={t('FOUR_DIGIT_PIN_CODE_PLACEHOLDER')}
                name={'pinCode'}
                type={'password'}
                {...form.props('pinCode')}
                style={{ width: '100%', padding: '0' }}
                inputProps={{ minLength: 4, maxLength: 4 }}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default UserAccountSection;
